import { useSelector } from 'react-redux';

const useCardLinkDomain = (): string => {
	const workspaceDomain = useSelector((state: any) => state.workspaceDomain);
	const whiteLabelSettings = useSelector((state: any) => state.whiteLabelSettings);

	// Priority 1: Active workspace domain
	if (workspaceDomain?.status === 'active') return workspaceDomain.domain;

	// Priority 2: Account-level custom domain (active)
	if (whiteLabelSettings?.connectionStatus && whiteLabelSettings?.sslStatus) return whiteLabelSettings.domain;

	// Priority 3: Current hostname
	return window.location.hostname;
};

export default useCardLinkDomain;
